// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* City input error styling - ensures red border appears when validation errors occur */
.city-input-error .MuiOutlinedInput-root {
  border-color: #d32f2f !important;
}

.city-input-error .MuiOutlinedInput-root:hover {
  border-color: #d32f2f !important;
}

.city-input-error .MuiOutlinedInput-root.Mui-focused {
  border-color: #d32f2f !important;
}

.city-input-error .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
  border-color: #d32f2f !important;
}

.city-input-error .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: #d32f2f !important;
}

.city-input-error .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #d32f2f !important;
}

/* Ensure error state is visible for city Select components */
.city-input-error .MuiFormControl-root .MuiOutlinedInput-root {
  border-color: #d32f2f !important;
}

.city-input-error .MuiFormControl-root .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
  border-color: #d32f2f !important;
}

.city-input-error .MuiFormControl-root .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: #d32f2f !important;
}

.city-input-error .MuiFormControl-root .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #d32f2f !important;
}


body {
  margin: 0;
  padding: 0;
  font-family: sans-serif;
}

/* Merchant pages background color - Updated to lighter rgba color */
.merchant-layout {
  /* background-color: rgba(247, 244, 250, 1) !important; */
  background-color: rgba(241, 241, 241, 0.4) !important;
}

/* Ensure merchant pages have consistent background */
[data-merchant-page="true"] {
  /* background-color: rgba(247, 244, 250, 1) !important; */
  background-color: rgba(241, 241, 241, 0.4) !important;

}

.btn-sm-ft {
  background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%) !important;
  color: var(--text-white);
  border-radius: 40px;
  padding: 8px 15px !important;
  font-size: 12px !important;
  font-weight: var(--font-medium);
  border: none;
  transition: background 0.5s ease;
  display: inline-block;
  width: fit-content;
}

.btn-sm-ft:hover {
  background: linear-gradient(90deg, var(--secondary-color) 0%, var(--primary-color) 100%) !important;
  transition: background 0.5s ease;
}

.btn-primary {
  background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%) !important;
  color: var(--text-white);
  border-radius: 40px;
  padding: 10px 28px;
  font-size: var(--font-15);
  font-weight: var(--font-medium);
  border: none;
  transition: background 0.5s ease;
  display: inline-block;
  width: fit-content;
}

.btn-primary:hover {
  background: linear-gradient(90deg, var(--secondary-color) 0%, var(--primary-color) 100%) !important;
  transition: background 0.5s ease;
}

.btn-secondary {
  background: var(--bg-white) !important;
  color: var(--text-primary) !important;
  border-radius: 40px;
  padding: 10px 28px;
  font-size: var(--font-size-regular);
  font-weight: var(--font-medium);
  border: none;
  transition: background 0.5s ease;
  display: inline-block;
  width: fit-content;
}


.btn-secondary:hover {
  background: var(--bg-white) !important;
  color: var(--text-primary) !important;
  transition: background 0.5s ease;
}

.font-heading {
  font-size: var(--font-size-xxxlarge);
  font-weight: var(--font-bold);
  color: var(--text-primary);
  margin-bottom: 15px;
  font-family: var(--font-codec-cold);
  line-height: 1.3;
}

.sections {
  padding: 50px 50px;
}

.sections-p-0 {
  padding: 50px 0px;
}

.bg-linear-gradient {
  background: linear-gradient(90deg,
      color-mix(in srgb, var(--primary-color) 15%, transparent) 0%,
      color-mix(in srgb, var(--secondary-color) 15%, transparent) 100%);
}

.bg-linear-gradient-40 {
  background: linear-gradient(90deg,
      color-mix(in srgb, var(--primary-color) 60%, transparent) 0%,
      color-mix(in srgb, var(--secondary-color) 60%, transparent) 100%);
}

.bg-linear-gradient-30 {
  background: linear-gradient(95deg,
      color-mix(in srgb, var(--primary-color) 30%, transparent) 0%,
      color-mix(in srgb, var(--secondary-color) 30%, transparent) 100%);
}

.bg-primary-light {
  background-color: rgba(99, 24, 198, 0.10);
}

.comman-gradient-header {
  min-height: 550px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-top: 100px;
}

.font-montserrat {
  font-family: var(--font-montserrat) !important;
  font-weight: var(--font-semibold) !important;
}

@media (min-width: 1024px) {
  .section-headings {
    padding: 40px 80px;
    padding: 40px 80px;
  }
}

@media (min-width: 1025px) and (max-width: 1280px) {
  .comman-gradient-header {
    min-height: 500px;
  }
}

@media (min-width: 1281px) and (max-width: 1440px) {
  .comman-gradient-header {
    min-height: 500px;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .btn-primary {
    padding: 10px 25px !important;
    font-size: var(--font-size-small) !important;
    font-weight: var(--font-medium) !important;
  }

  .btn-secondary {
    padding: 10px 25px !important;
    font-size: var(--font-size-small) !important;
    font-weight: var(--font-medium) !important;
  }

  .font-heading {
    font-size: var(--font-size-xlarge);
  }

  .comman-gradient-header h1 {
    font-size: var(--font-size-xlarge);
  }

  .comman-gradient-header h3 {
    font-size: var(--font-size-large);
  }

  .details-3 {
    font-size: var(--font-size-medium);
  }

  .ct-details p a {
    font-size: var(--font-size-large);
  }
}

/* .merchant-layout-content {
  padding-top: 72px;
} */

@media (max-width: 767px) {

  .sections-p-0 {
    padding: 50px 0px 0px 0 !important;
  }


  .ai-model-studio {
    padding-top: 15px !important;
  }

  .merchant-layout-content {
    padding-top: 72px;
  }

  .css-zfu8fu:has(.mt-mb-0) {
    margin-top: 10px !important;
  }

  .btn-secondary {
    padding: 8px 21px;
    font-size: var(--font-size-small);
  }

  .btn-primary {
    padding: 8px 21px;
    font-size: var(--font-size-small) !important;
  }

  .font-heading {
    font-size: var(--font-size-regular);
    font-weight: var(--font-bold);
    line-height: 1.4;
  }

  .sections {
    padding: 32px 10px;
  }

}

/* Disabled button styles - Make text color white for all disabled buttons */
/* .btn:disabled,
.btn.disabled,
button:disabled,
button.disabled,
input[type="button"]:disabled,
input[type="submit"]:disabled,
input[type="reset"]:disabled,
[type="button"]:disabled,
[type="submit"]:disabled,
[type="reset"]:disabled {
  color: var(--text-white) !important;
  opacity: 0.7 !important;
} */

/* Override Bootstrap's default disabled button styles */
.btn.disabled,
.btn:disabled,
fieldset:disabled .btn {
  color: var(--text-white) !important;
}

/* Ensure disabled buttons maintain white text even with Bootstrap classes */
.btn-primary:disabled,
.btn-primary.disabled,
.btn-secondary:disabled,
.btn-secondary.disabled,
.btn-success:disabled,
.btn-success.disabled,
.btn-danger:disabled,
.btn-danger.disabled,
.btn-warning:disabled,
.btn-warning.disabled,
.btn-info:disabled,
.btn-info.disabled,
.btn-light:disabled,
.btn-light.disabled,
.btn-dark:disabled,
.btn-dark.disabled {
  color: var(--text-white) !important;
}

/* City input error styling - ensures red border appears when validation errors occur */
.city-input-error .MuiOutlinedInput-root {
  border-color: #d32f2f !important;
}

.city-input-error .MuiOutlinedInput-root:hover {
  border-color: #d32f2f !important;
}

.city-input-error .MuiOutlinedInput-root.Mui-focused {
  border-color: #d32f2f !important;
}

.city-input-error .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
  border-color: #d32f2f !important;
}

.city-input-error .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: #d32f2f !important;
}

.city-input-error .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #d32f2f !important;
}

/* Ensure error state is visible for city Select components */
.city-input-error .MuiFormControl-root .MuiOutlinedInput-root {
  border-color: #d32f2f !important;
}

.city-input-error .MuiFormControl-root .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
  border-color: #d32f2f !important;
}

.city-input-error .MuiFormControl-root .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: #d32f2f !important;
}

.city-input-error .MuiFormControl-root .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #d32f2f !important;
}


.file-btn {
  font-size: 30px !important;
}

/* ========================================= */
/* NEW REUSABLE CSS CLASSES (Added Recently) */
/* ========================================= */

.btn-primary {
  background: linear-gradient(90deg, #A864ED 0%, #F5B760 100%) !important;
  color: #fff !important;
  border-radius: 10px !important;
  padding: 12px 24px !important;
  font-size: 16px !important;
  border: none !important;
  transition: background 0.5s ease;
  display: inline-block;
  width: fit-content;
  box-shadow: none !important;
  text-transform: none !important;
  font-family: var(--font-montserrat-semibold) !important;
}

.btn-primary:hover {
  background: linear-gradient(90deg, #9C52DB 0%, #EAA24A 100%) !important;
  box-shadow: none !important;
}

.btn-primary.Mui-disabled,
.btn-primary:disabled {
  background: #eee !important;
  color: #aaa !important;
}

.form-label {
  font-weight: 600 !important;
  font-size: var(--font-size-small) !important;
  color: var(--input-color1) !important;
  font-family: var(--font-montserrat-semibold) !important;
}

.ab-form-label {
  font-family: var(--font-montserrat-semibold), sans-serif !important;
  font-weight: 600 !important;
  font-size: 15.15px !important;
  color: #1E2939 !important;
  display: block;
  margin-bottom: 8px;
}

.form-control {
  margin-bottom: 16px !important;

}

.font-montserret-semibold {
  font-family: var(--font-montserrat-semibold) !important;
  font-weight: 600 !important;
}

/* .MuiFormControlLabel-root span {
  padding: 0px 6px !important;
} */

.font-roboto-condensed {
  font-family: var(--font-roboto) !important;
  font-weight: 400 !important;
}

.form-control .MuiOutlinedInput-root {
  border-radius: 10px !important;
  height: var(--input-height-44) !important;
}

.form-control .MuiOutlinedInput-root fieldset {
  border-color: var(--placeholder1) !important;
}

.form-control .MuiOutlinedInput-root:hover fieldset,
.form-control .MuiOutlinedInput-root.Mui-focused fieldset {
  border-color: var(--placeholder1) !important;
}

.form-control input {
  padding: 0 19px !important;
  font-weight: 500 !important;
  font-size: var(--font-size-small) !important;
  color: var(--input-color1) !important;
  font-family: var(--font-montserrat-medium) !important;
  height: 100% !important;
  box-sizing: border-box !important;
}

.form-control.muiBase-control input {
  padding: 5px 14px 5px 2px !important;
}


.form-control input::placeholder {
  color: var(--placeholder1) !important;
  font-weight: 300 !important;
  font-size: var(--font-size-small) !important;
  font-family: var(--font-readex-pro-light) !important;
  opacity: 1 !important;
}

.login-text {
  font-weight: 600 !important;
  font-size: var(--font-size-small) !important;
  color: var(--input-color1) !important;
  font-family: var(--font-montserrat-semibold) !important;
}

@media (max-width: 767px) {
  .form-label {
    font-size: 13px !important;
  }
}

/* Custom Photo Tabs */
.photo-tab {
  width: 49%;
  padding: 10px 12px;
  border-radius: 15.1px;
  font-size: 14.1px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #d1d5db;
  background-color: #fff;
  color: #000;
  font-family: var(--font-montserrat-medium), sans-serif;
  text-align: center;
}

.photo-tab.active {
  background-color: #6318C6;
  color: #fff;
  border-color: #6318C6;
}

.btn-click {
  background-color: #E8E4F0 !important;
  color: #651BC6 !important;
  border-radius: 10.8px !important;
  padding: 10px 20px !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  border: none !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  font-family: "Montserrat", sans-serif !important;
  text-transform: none !important;
  box-shadow: none !important;
}

@media (max-width: 600px) {
  .btn-click {
    font-size: 14.03px !important;
    padding: 12px 23px !important;
  }
}

.btn-click:hover {
  background-color: #dad4e8 !important;
}

.guideline-link {
  color: #651BC6 !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  text-decoration: none !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 4px !important;
  cursor: pointer !important;
  font-family: "Montserrat", sans-serif !important;
  text-transform: none !important;
  margin-top: 15px !important;
}

@media (max-width: 600px) {
  .guideline-link {
    font-size: 11.99px !important;
  }
}

.guideline-link:hover {
  text-decoration: none !important;
  opacity: 0.8;
}

.up-area {
  padding: 20px 20px !important;
}

.border-outln {
  border: 1px solid #651BC6 !important;
}

.ai-attributes-title {
  font-size: 17.31px;
  font-family: var(--font-montserrat-semibold) !important;
  color: #1E2939;
}

/* Jewellery Type Grid */
.select-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-top: 15px;
  margin-bottom: 5px;
}

@media (min-width: 1024px) {
  .select-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}

.select-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  width: 100%;
}

.select-box {
  width: 100px;
  aspect-ratio: 1 / 1;
  background-color: #fff;
  border: 2px solid #D1D1D1;
  border-radius: 11.69px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.3s ease;
  padding: 12px;
  box-sizing: border-box;
  overflow: hidden;
  height: 100px;
}

.model-face-select-box {
  height: 160px !important;
}

.model-face-select-box img {
  object-fit: cover !important;
}

.select-box.selected {
  border: 2px solid #651BC6;
}

.select-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
}

.select-checkbox {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 18px;
  height: 18px;
  border: 2px solid #651BC6;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  z-index: 2;
}

.select-label {
  font-family: var(--font-montserrat-medium) !important;
  font-size: 14.17px !important;
  color: #000;
  text-align: center;
  font-weight: 500;
  transition: all 0.3s ease;
  line-height: 1.2;
  width: 100%;
  padding: 0 4px;
  box-sizing: border-box;
  white-space: normal !important;
  overflow-wrap: break-word !important;
  word-break: break-word !important;
}

.select-item.selected .select-label {
  color: #651BC6 !important;
}

/* Specific styling for AI Attributes (Ethnicity, Clothing Type, Bust Finish) to fill card completely */
.attribute-select-box {
  padding: 0 !important;
  background-color: #CFC2AC !important;
}

.attribute-select-image {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}

.model-face-select-image {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain !important;
}

.model-face-select-box {
  background-color: #fff !important;
}

@media (max-width: 767px) {
  .jewellery-grid {
    gap: 10px;
  }

  .jewellery-label {
    font-size: 13.5px;
  }
}

@media (min-width: 768px) {
  .photo-tab {
    padding: 10px 12px;
  }
}

/* Radio Button Select Cards */
.select-radio {
  margin: 0 !important;
  border: 2px solid #D1D1D1 !important;
  border-radius: 15.15px !important;
  padding: 12px 16px !important;
  transition: all 0.3s ease !important;
  background-color: white !important;
  flex: 1 1 !important;
  height: 53px !important;
  min-height: 53px !important;
  display: flex !important;
  align-items: center !important;
  box-sizing: border-box !important;
  min-width: 0 !important;
}

.select-radio:hover {
  border-color: #651BC6 !important;
  background-color: #F9F6FE !important;
}

.select-radio.selected {
  border-color: #651BC6 !important;
  border-width: 2px !important;
  background-color: #F9F6FE !important;
}

.select-radio .MuiRadio-root {
  padding: 8px !important;
  margin-right: 2px !important;
  color: #D1D1D1 !important;
}

.select-radio .MuiRadio-root:hover {
  background-color: rgba(101, 27, 198, 0.04) !important;
}

.select-radio .MuiRadio-root.Mui-checked {
  color: #651BC6 !important;
}

.select-radio .MuiRadio-root.Mui-checked svg:nth-of-type(2),
.select-radio .MuiRadio-root.Mui-checked svg[data-testid="RadioButtonCheckedIcon"] {
  transform: scale(0.8) !important;
  transform-origin: center !important;
}

.select-radio .MuiSvgIcon-root {
  font-size: 22px !important;
  margin-right: 2px !important;
}

.select-radio .MuiFormControlLabel-label {
  color: #1F2937 !important;
  flex: 1 1 !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  font-family: var(--font-montserrat-medium) !important;
  font-weight: 500 !important;
  font-size: 15.15px !important;
}

.select-radio .MuiFormControlLabel-label span {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  min-width: 0 !important;
}

.select-radio.selected .MuiFormControlLabel-label span {
  color: #651BC6 !important;
}

@media (max-width: 380px) {
  .select-radio {
    padding: 8px 10px !important;
  }

  .select-radio .MuiFormControlLabel-label {
    font-size: 14.17px !important;
    gap: 2px !important;
  }
}

/* Media Quality Popup Styles */
.media-title {
  color: #1E2939 !important;
  font-weight: 600 !important;
  margin-bottom: 24px !important;
  font-family: var(--font-montserrat-semibold) !important;
  font-size: 15.15px !important;
}

.media-label {
  font-weight: 700 !important;
  color: #1E2939 !important;
  font-size: 11.07px !important;
  margin-bottom: 1.6px !important;
  font-family: var(--font-montserrat-bold) !important;
  text-align: center;
}

.media-res {
  color: #1E2939 !important;
  font-size: 11.07px !important;
  font-weight: 500 !important;
  font-family: var(--font-montserrat-medium) !important;
  text-align: center;
}

.item-label {
  font-size: 14.5px !important;
  color: #9B9B9B !important;
  font-family: var(--font-montserrat-medium) !important;
  font-weight: 500 !important;
  margin-bottom: 3px !important;
  line-height: 1.3 !important;
}

.item-value {
  font-size: 14.5px !important;
  color: #111827 !important;
  font-family: var(--font-montserrat-semibold) !important;
  font-weight: 700 !important;
  line-height: 1.3 !important;
}

.generation-details {
  border-radius: 10.29px;
  border: 1px solid #E5E7EB;
  padding: 16px 20px;
  margin-bottom: 5px;
}

.dialog-actions-custom {
  padding: 15px 17px 15px 17px !important;
  /* pt:0.5, px:2.5, pb:2.5 */
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  /* 1.5 * 8 = 12px */
  justify-content: stretch;
  border-top: 1px solid #E5E7EB;

  /* box shadow */
  box-shadow: 0px -3.48px 10.43px 0px rgba(0, 0, 0, 0.05);
}

.font-14 {
  font-size: 14px !important;
}

.p-12-0 {
  padding: 12px 0px !important;
}

.preview-content {
  padding: 12px 14px 7px 14px !important;
}

.loader-card {
  padding: 50px 20px 10px 20px;
}

.loader-card-progress {
  padding: 10px 30px;
}

/* Profile Form Styles */
.profile-input-label {
  font-family: 'Montserrat', sans-serif !important;
  font-size: 14px !important;
  color: #000000 !important;
  font-weight: 500 !important;
  margin-bottom: 8px !important;
}

.profile-form-control .MuiOutlinedInput-root {
  border-radius: 13.47px !important;
  height: 48px !important;
  background-color: #ffffff;
}

.profile-form-control .MuiOutlinedInput-notchedOutline {
  border-color: #C1C1C1 !important;
}

.profile-form-control .MuiInputBase-input {
  font-family: 'Montserrat', sans-serif !important;
  font-size: 14px !important;
  color: #000 !important;
  font-weight: 400 !important;
}

.profile-form-control .MuiInputBase-input::placeholder {
  font-family: 'Montserrat', sans-serif !important;
  font-size: 14px !important;
  color: #919191 !important;
  font-weight: 400 !important;
  opacity: 1 !important;
}

/* Generation History Action Buttons */
.action-button-grid {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 12px !important;
}

.action-btn {
  height: 40px !important;
  border-radius: 10.96px !important;
  border: 1px solid #E5E7EB !important;
  background-color: #F3F4F6 !important;
  color: #6B7280 !important;
  font-weight: 500 !important;
  text-transform: none !important;
  font-size: 14px !important;
  font-family: var(--font-montserrat-medium, Montserrat, sans-serif) !important;
}

.action-btn:hover:not(:disabled):not(.Mui-disabled) {
  background-color: #6318C6 !important;
  border-color: #6318C6 !important;
  color: #fff !important;
}

.action-btn:disabled,
.action-btn.Mui-disabled {
  background-color: #F3F4F6 !important;
  border-color: #E5E7EB !important;
  color: #6B7280 !important;
}

/* Generation History Card Typography and Layout classes */
.gen-thumbnail {
  width: 90px;
  height: 150px;
  border-radius: 12px;
  flex-shrink: 0;
  overflow: hidden;
  background-color: #f5f5f5;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.gen-video-preview {
  width: 90px;
  height: 150px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s ease;
}

.gen-video-preview:hover {
  transform: scale(1.03);
}

.gen-play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.55);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.gen-video-placeholder {
  width: 90px;
  height: 90px;
  background-color: #1e293b;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative;
  cursor: pointer;
}

/* Category Title */
.gen-category-title {
  font-size: 17.53px !important;
  font-weight: 600 !important;
  color: #1E2939 !important;
  font-family: var(--font-montserrat-semibold, Montserrat, sans-serif) !important;
  margin-bottom: 6px !important;
  line-height: 1.3 !important;
}

/* Status Badges */
.gen-badge-processing {
  height: 30px;
  display: inline-flex !important;
  align-items: center !important;
  padding: 0 12px !important;
  border-radius: 100px !important;
  background-color: #DBEAFE !important;
  color: #1D4ED8 !important;
  font-family: var(--font-montserrat-semibold, Montserrat, sans-serif) !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  white-space: nowrap !important;
}

.gen-badge-completed {
  height: 30px;
  display: inline-flex !important;
  align-items: center !important;
  padding: 0 12px !important;
  border-radius: 100px !important;
  background-color: #D1FAE5 !important;
  color: #065F46 !important;
  font-family: var(--font-montserrat-semibold, Montserrat, sans-serif) !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  white-space: nowrap !important;
}

.gen-badge-failed {
  height: 30px;
  display: inline-flex !important;
  align-items: center !important;
  padding: 0 12px !important;
  border-radius: 100px !important;
  background-color: #FEE2E2 !important;
  color: #B91C1C !important;
  font-family: var(--font-montserrat-semibold, Montserrat, sans-serif) !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  white-space: nowrap !important;
}

.gen-badge-cancelled {
  height: 30px;
  display: inline-flex !important;
  align-items: center !important;
  padding: 0 12px !important;
  border-radius: 100px !important;
  background-color: #FED7AA !important;
  color: #EA580C !important;
  font-family: var(--font-montserrat-semibold, Montserrat, sans-serif) !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  white-space: nowrap !important;
}

/* Points Badge */
.gen-badge-tokens {
  height: 30px;
  display: inline-flex !important;
  align-items: center !important;
  padding: 0 12px !important;
  border-radius: 100px !important;
  background-color: #EDE9FE !important;
  color: #7C3AED !important;
  font-family: var(--font-montserrat-semibold, Montserrat, sans-serif) !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  white-space: nowrap !important;
}

/* Date Time Text */
.gen-datetime {
  font-size: 13.45px !important;
  color: #515151 !important;
  font-family: var(--font-montserrat-regular, Montserrat, sans-serif) !important;
  font-weight: 400 !important;
}

/* Custom Tags Wrapper */
.gen-tags-title {
  font-size: 15px !important;
  color: #000000 !important;
  font-family: var(--font-montserrat-medium, Montserrat, sans-serif) !important;
  font-weight: 500 !important;
  margin-bottom: 8px !important;
}

/* Custom Tag Item */
.gen-tag-item {
  height: 30px;
  display: inline-flex !important;
  align-items: center !important;
  padding: 0 12px !important;
  border-radius: 100px !important;
  background-color: #651BC6 !important;
  color: #fff !important;
  font-family: var(--font-montserrat-medium, Montserrat, sans-serif) !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  white-space: nowrap !important;
}

/* Custom Tag Extra (+N) */
.gen-tag-extra {
  width: 30px;
  height: 30px;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 100px !important;
  background-color: #EDE9FE !important;
  color: #7C3AED !important;
  font-family: var(--font-montserrat-medium, Montserrat, sans-serif) !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  cursor: pointer;
  flex-shrink: 0;
}

/* Custom Tag Show Less */
.gen-tag-less {
  height: 30px;
  display: inline-flex !important;
  align-items: center !important;
  padding: 0 12px !important;
  border-radius: 100px !important;
  background-color: #F3F4F6 !important;
  color: #6B7280 !important;
  font-family: var(--font-montserrat-medium, Montserrat, sans-serif) !important;
  font-weight: 500 !important;
  font-size: 12px !important;
  cursor: pointer;
}


@media (max-width: 375px) {
  .gen-thumbnail {
    width: 87px !important;
    height: 140px !important;
  }

  .gen-category-title {
    font-size: 15.53px !important;
    margin-bottom: 7px !important;
  }

  .gen-badge-failed,
  .gen-badge-completed,
  .gen-badge-processing,
  .gen-badge-cancelled,
  .gen-badge-tokens {
    height: 25px !important;
    font-size: 12px !important;
  }

  .gen-datetime {
    font-size: 11.45px !important;
  }

  .gen-tags-title {
    font-size: 13px !important;
  }

  .gen-tag-item {
    height: 28px !important;
    padding: 2px 14px !important;
    font-size: 11px !important;
  }

  .gen-tag-extra {
    width: 28px !important;
    height: 28px !important;
    font-size: 12.45px !important;
  }

  .action-btn {
    height: 38px !important;
    font-size: 13px !important;
  }

  .gen-tag-less {
    height: 28px !important;
    padding: 2px 14px !important;
    font-size: 12px !important;
  }

  /* Custom date picker styling to allow native calendar overlay on the full input */
  .custom-date-picker::-webkit-calendar-picker-indicator {
    background: transparent;
    bottom: 0;
    color: transparent;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
  }
}

.btn-primary-app {
  background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%) !important;
  color: var(--text-white);
  border-radius: 40px;
  padding: 10px 28px;
  font-size: var(--font-size-regular);
  font-weight: var(--font-medium);
  border: none;
  transition: background 0.5s ease;
  display: inline-block;
  width: fit-content;
}

.btn-primary-web {
  background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%) !important;
  color: var(--text-white);
  border-radius: 40px;
  padding: 10px 28px;
  font-size: var(--font-size-small);
  font-weight: var(--font-medium);
  border: none;
  transition: background 0.5s ease;
  display: inline-block;
  width: fit-content;
}

.btn-primary-web:hover {
  background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%) !important;
  transition: background 0.5s ease;
  color: var(--text-white);

}

@media (max-width: 767px) {
  .text-span {
    font-size: 9px !important;
  }
}

.text-span {
  font-size: 10px;
  letter-spacing: 0.5px;
  color: #000000;
  font-family: var(--font-montserrat-medium)
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,uFAAuF;AACvF;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,6DAA6D;AAC7D;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;;AAGA;EACE,SAAS;EACT,UAAU;EACV,uBAAuB;AACzB;;AAEA,oEAAoE;AACpE;EACE,yDAAyD;EACzD,qDAAqD;AACvD;;AAEA,qDAAqD;AACrD;EACE,yDAAyD;EACzD,qDAAqD;;AAEvD;;AAEA;EACE,mGAAmG;EACnG,wBAAwB;EACxB,mBAAmB;EACnB,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,YAAY;EACZ,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mGAAmG;EACnG,gCAAgC;AAClC;;AAEA;EACE,mGAAmG;EACnG,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;EAC/B,YAAY;EACZ,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mGAAmG;EACnG,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;EAC/B,YAAY;EACZ,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;AACpB;;;AAGA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,0BAA0B;EAC1B,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;;uEAEqE;AACvE;;AAEA;EACE;;uEAEqE;AACvE;;AAEA;EACE;;uEAEqE;AACvE;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;EAC9C,4CAA4C;AAC9C;;AAEA;EACE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,4CAA4C;IAC5C,0CAA0C;EAC5C;;EAEA;IACE,6BAA6B;IAC7B,4CAA4C;IAC5C,0CAA0C;EAC5C;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,iCAAiC;EACnC;AACF;;AAEA;;GAEG;;AAEH;;EAEE;IACE,kCAAkC;EACpC;;;EAGA;IACE,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;IACjB,4CAA4C;EAC9C;;EAEA;IACE,mCAAmC;IACnC,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;AAEF;;AAEA,4EAA4E;AAC5E;;;;;;;;;;;;GAYG;;AAEH,wDAAwD;AACxD;;;EAGE,mCAAmC;AACrC;;AAEA,4EAA4E;AAC5E;;;;;;;;;;;;;;;;EAgBE,mCAAmC;AACrC;;AAEA,uFAAuF;AACvF;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,6DAA6D;AAC7D;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;;AAGA;EACE,0BAA0B;AAC5B;;AAEA,8CAA8C;AAC9C,8CAA8C;AAC9C,8CAA8C;;AAE9C;EACE,uEAAuE;EACvE,sBAAsB;EACtB,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;EAC3B,+BAA+B;EAC/B,uDAAuD;AACzD;;AAEA;EACE,uEAAuE;EACvE,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,qCAAqC;EACrC,uDAAuD;AACzD;;AAEA;EACE,mEAAmE;EACnE,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;;AAEhC;;AAEA;EACE,uDAAuD;EACvD,2BAA2B;AAC7B;;AAEA;;GAEG;;AAEH;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,4CAA4C;EAC5C,qCAAqC;EACrC,qDAAqD;EACrD,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;;AAGA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,4CAA4C;EAC5C,oDAAoD;EACpD,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,qCAAqC;EACrC,uDAAuD;AACzD;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,sDAAsD;EACtD,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,0BAA0B;EAC1B,oCAAoC;EACpC,gDAAgD;EAChD,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE;IACE,6BAA6B;IAC7B,6BAA6B;EAC/B;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B,gDAAgD;EAChD,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,uDAAuD;EACvD,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,qDAAqD;EACrD,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,8BAA8B;EAC9B,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uGAAuG;AACvG;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;EAC7B,oCAAoC;EACpC,kCAAkC;EAClC,oBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,oBAAkB;EAClB,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,qDAAqD;EACrD,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,mBAAmB;EACrB;AACF;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;EAC9B,uDAAuD;EACvD,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,6BAA6B;EAC7B,+BAA+B;EAC/B,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,qDAAqD;EACrD,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,uDAAuD;EACvD,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;EAC3B,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,wBAAwB;EACxB,6BAA6B;;EAE7B,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,gDAAgD;EAChD,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gDAAgD;EAChD,0BAA0B;EAC1B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,gDAAgD;EAChD,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,wBAAwB;EACxB,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;EAC3B,+BAA+B;EAC/B,0BAA0B;EAC1B,6EAA6E;AAC/E;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,0DAA0D;AAC1D;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,+EAA+E;EAC/E,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,+BAA+B;EAC/B,8BAA8B;EAC9B,0BAA0B;EAC1B,+BAA+B;EAC/B,oCAAoC;EACpC,yBAAyB;EACzB,+EAA+E;EAC/E,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,8BAA8B;EAC9B,0BAA0B;EAC1B,+BAA+B;EAC/B,oCAAoC;EACpC,yBAAyB;EACzB,+EAA+E;EAC/E,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,8BAA8B;EAC9B,0BAA0B;EAC1B,+BAA+B;EAC/B,oCAAoC;EACpC,yBAAyB;EACzB,+EAA+E;EAC/E,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,8BAA8B;EAC9B,0BAA0B;EAC1B,+BAA+B;EAC/B,oCAAoC;EACpC,yBAAyB;EACzB,+EAA+E;EAC/E,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,+BAA+B;EAC/B,8BAA8B;EAC9B,0BAA0B;EAC1B,+BAA+B;EAC/B,oCAAoC;EACpC,yBAAyB;EACzB,+EAA+E;EAC/E,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,8EAA8E;EAC9E,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,6EAA6E;EAC7E,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,+BAA+B;EAC/B,8BAA8B;EAC9B,0BAA0B;EAC1B,+BAA+B;EAC/B,oCAAoC;EACpC,sBAAsB;EACtB,6EAA6E;EAC7E,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,oCAAoC;EACpC,yBAAyB;EACzB,6EAA6E;EAC7E,2BAA2B;EAC3B,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,+BAA+B;EAC/B,8BAA8B;EAC9B,0BAA0B;EAC1B,+BAA+B;EAC/B,oCAAoC;EACpC,yBAAyB;EACzB,6EAA6E;EAC7E,2BAA2B;EAC3B,0BAA0B;EAC1B,eAAe;AACjB;;;AAGA;EACE;IACE,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;;;;;IAKE,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA,kFAAkF;EAClF;IACE,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,WAAW;EACb;AACF;;AAEA;EACE,mGAAmG;EACnG,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;EAC/B,YAAY;EACZ,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mGAAmG;EACnG,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;EACjC,+BAA+B;EAC/B,YAAY;EACZ,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mGAAmG;EACnG,gCAAgC;EAChC,wBAAwB;;AAE1B;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd;AACF","sourcesContent":["/* City input error styling - ensures red border appears when validation errors occur */\n.city-input-error .MuiOutlinedInput-root {\n  border-color: #d32f2f !important;\n}\n\n.city-input-error .MuiOutlinedInput-root:hover {\n  border-color: #d32f2f !important;\n}\n\n.city-input-error .MuiOutlinedInput-root.Mui-focused {\n  border-color: #d32f2f !important;\n}\n\n.city-input-error .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {\n  border-color: #d32f2f !important;\n}\n\n.city-input-error .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n  border-color: #d32f2f !important;\n}\n\n.city-input-error .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #d32f2f !important;\n}\n\n/* Ensure error state is visible for city Select components */\n.city-input-error .MuiFormControl-root .MuiOutlinedInput-root {\n  border-color: #d32f2f !important;\n}\n\n.city-input-error .MuiFormControl-root .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {\n  border-color: #d32f2f !important;\n}\n\n.city-input-error .MuiFormControl-root .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n  border-color: #d32f2f !important;\n}\n\n.city-input-error .MuiFormControl-root .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #d32f2f !important;\n}\n\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: sans-serif;\n}\n\n/* Merchant pages background color - Updated to lighter rgba color */\n.merchant-layout {\n  /* background-color: rgba(247, 244, 250, 1) !important; */\n  background-color: rgba(241, 241, 241, 0.4) !important;\n}\n\n/* Ensure merchant pages have consistent background */\n[data-merchant-page=\"true\"] {\n  /* background-color: rgba(247, 244, 250, 1) !important; */\n  background-color: rgba(241, 241, 241, 0.4) !important;\n\n}\n\n.btn-sm-ft {\n  background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%) !important;\n  color: var(--text-white);\n  border-radius: 40px;\n  padding: 8px 15px !important;\n  font-size: 12px !important;\n  font-weight: var(--font-medium);\n  border: none;\n  transition: background 0.5s ease;\n  display: inline-block;\n  width: fit-content;\n}\n\n.btn-sm-ft:hover {\n  background: linear-gradient(90deg, var(--secondary-color) 0%, var(--primary-color) 100%) !important;\n  transition: background 0.5s ease;\n}\n\n.btn-primary {\n  background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%) !important;\n  color: var(--text-white);\n  border-radius: 40px;\n  padding: 10px 28px;\n  font-size: var(--font-15);\n  font-weight: var(--font-medium);\n  border: none;\n  transition: background 0.5s ease;\n  display: inline-block;\n  width: fit-content;\n}\n\n.btn-primary:hover {\n  background: linear-gradient(90deg, var(--secondary-color) 0%, var(--primary-color) 100%) !important;\n  transition: background 0.5s ease;\n}\n\n.btn-secondary {\n  background: var(--bg-white) !important;\n  color: var(--text-primary) !important;\n  border-radius: 40px;\n  padding: 10px 28px;\n  font-size: var(--font-size-regular);\n  font-weight: var(--font-medium);\n  border: none;\n  transition: background 0.5s ease;\n  display: inline-block;\n  width: fit-content;\n}\n\n\n.btn-secondary:hover {\n  background: var(--bg-white) !important;\n  color: var(--text-primary) !important;\n  transition: background 0.5s ease;\n}\n\n.font-heading {\n  font-size: var(--font-size-xxxlarge);\n  font-weight: var(--font-bold);\n  color: var(--text-primary);\n  margin-bottom: 15px;\n  font-family: var(--font-codec-cold);\n  line-height: 1.3;\n}\n\n.sections {\n  padding: 50px 50px;\n}\n\n.sections-p-0 {\n  padding: 50px 0px;\n}\n\n.bg-linear-gradient {\n  background: linear-gradient(90deg,\n      color-mix(in srgb, var(--primary-color) 15%, transparent) 0%,\n      color-mix(in srgb, var(--secondary-color) 15%, transparent) 100%);\n}\n\n.bg-linear-gradient-40 {\n  background: linear-gradient(90deg,\n      color-mix(in srgb, var(--primary-color) 60%, transparent) 0%,\n      color-mix(in srgb, var(--secondary-color) 60%, transparent) 100%);\n}\n\n.bg-linear-gradient-30 {\n  background: linear-gradient(95deg,\n      color-mix(in srgb, var(--primary-color) 30%, transparent) 0%,\n      color-mix(in srgb, var(--secondary-color) 30%, transparent) 100%);\n}\n\n.bg-primary-light {\n  background-color: rgba(99, 24, 198, 0.10);\n}\n\n.comman-gradient-header {\n  min-height: 550px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding-top: 100px;\n}\n\n.font-montserrat {\n  font-family: var(--font-montserrat) !important;\n  font-weight: var(--font-semibold) !important;\n}\n\n@media (min-width: 1024px) {\n  .section-headings {\n    padding: 40px 80px;\n    padding: 40px 80px;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1280px) {\n  .comman-gradient-header {\n    min-height: 500px;\n  }\n}\n\n@media (min-width: 1281px) and (max-width: 1440px) {\n  .comman-gradient-header {\n    min-height: 500px;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .btn-primary {\n    padding: 10px 25px !important;\n    font-size: var(--font-size-small) !important;\n    font-weight: var(--font-medium) !important;\n  }\n\n  .btn-secondary {\n    padding: 10px 25px !important;\n    font-size: var(--font-size-small) !important;\n    font-weight: var(--font-medium) !important;\n  }\n\n  .font-heading {\n    font-size: var(--font-size-xlarge);\n  }\n\n  .comman-gradient-header h1 {\n    font-size: var(--font-size-xlarge);\n  }\n\n  .comman-gradient-header h3 {\n    font-size: var(--font-size-large);\n  }\n\n  .details-3 {\n    font-size: var(--font-size-medium);\n  }\n\n  .ct-details p a {\n    font-size: var(--font-size-large);\n  }\n}\n\n/* .merchant-layout-content {\n  padding-top: 72px;\n} */\n\n@media (max-width: 767px) {\n\n  .sections-p-0 {\n    padding: 50px 0px 0px 0 !important;\n  }\n\n\n  .ai-model-studio {\n    padding-top: 15px !important;\n  }\n\n  .merchant-layout-content {\n    padding-top: 72px;\n  }\n\n  .css-zfu8fu:has(.mt-mb-0) {\n    margin-top: 10px !important;\n  }\n\n  .btn-secondary {\n    padding: 8px 21px;\n    font-size: var(--font-size-small);\n  }\n\n  .btn-primary {\n    padding: 8px 21px;\n    font-size: var(--font-size-small) !important;\n  }\n\n  .font-heading {\n    font-size: var(--font-size-regular);\n    font-weight: var(--font-bold);\n    line-height: 1.4;\n  }\n\n  .sections {\n    padding: 32px 10px;\n  }\n\n}\n\n/* Disabled button styles - Make text color white for all disabled buttons */\n/* .btn:disabled,\n.btn.disabled,\nbutton:disabled,\nbutton.disabled,\ninput[type=\"button\"]:disabled,\ninput[type=\"submit\"]:disabled,\ninput[type=\"reset\"]:disabled,\n[type=\"button\"]:disabled,\n[type=\"submit\"]:disabled,\n[type=\"reset\"]:disabled {\n  color: var(--text-white) !important;\n  opacity: 0.7 !important;\n} */\n\n/* Override Bootstrap's default disabled button styles */\n.btn.disabled,\n.btn:disabled,\nfieldset:disabled .btn {\n  color: var(--text-white) !important;\n}\n\n/* Ensure disabled buttons maintain white text even with Bootstrap classes */\n.btn-primary:disabled,\n.btn-primary.disabled,\n.btn-secondary:disabled,\n.btn-secondary.disabled,\n.btn-success:disabled,\n.btn-success.disabled,\n.btn-danger:disabled,\n.btn-danger.disabled,\n.btn-warning:disabled,\n.btn-warning.disabled,\n.btn-info:disabled,\n.btn-info.disabled,\n.btn-light:disabled,\n.btn-light.disabled,\n.btn-dark:disabled,\n.btn-dark.disabled {\n  color: var(--text-white) !important;\n}\n\n/* City input error styling - ensures red border appears when validation errors occur */\n.city-input-error .MuiOutlinedInput-root {\n  border-color: #d32f2f !important;\n}\n\n.city-input-error .MuiOutlinedInput-root:hover {\n  border-color: #d32f2f !important;\n}\n\n.city-input-error .MuiOutlinedInput-root.Mui-focused {\n  border-color: #d32f2f !important;\n}\n\n.city-input-error .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {\n  border-color: #d32f2f !important;\n}\n\n.city-input-error .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n  border-color: #d32f2f !important;\n}\n\n.city-input-error .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #d32f2f !important;\n}\n\n/* Ensure error state is visible for city Select components */\n.city-input-error .MuiFormControl-root .MuiOutlinedInput-root {\n  border-color: #d32f2f !important;\n}\n\n.city-input-error .MuiFormControl-root .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {\n  border-color: #d32f2f !important;\n}\n\n.city-input-error .MuiFormControl-root .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n  border-color: #d32f2f !important;\n}\n\n.city-input-error .MuiFormControl-root .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #d32f2f !important;\n}\n\n\n.file-btn {\n  font-size: 30px !important;\n}\n\n/* ========================================= */\n/* NEW REUSABLE CSS CLASSES (Added Recently) */\n/* ========================================= */\n\n.btn-primary {\n  background: linear-gradient(90deg, #A864ED 0%, #F5B760 100%) !important;\n  color: #fff !important;\n  border-radius: 10px !important;\n  padding: 12px 24px !important;\n  font-size: 16px !important;\n  border: none !important;\n  transition: background 0.5s ease;\n  display: inline-block;\n  width: fit-content;\n  box-shadow: none !important;\n  text-transform: none !important;\n  font-family: var(--font-montserrat-semibold) !important;\n}\n\n.btn-primary:hover {\n  background: linear-gradient(90deg, #9C52DB 0%, #EAA24A 100%) !important;\n  box-shadow: none !important;\n}\n\n.btn-primary.Mui-disabled,\n.btn-primary:disabled {\n  background: #eee !important;\n  color: #aaa !important;\n}\n\n.form-label {\n  font-weight: 600 !important;\n  font-size: var(--font-size-small) !important;\n  color: var(--input-color1) !important;\n  font-family: var(--font-montserrat-semibold) !important;\n}\n\n.ab-form-label {\n  font-family: var(--font-montserrat-semibold), sans-serif !important;\n  font-weight: 600 !important;\n  font-size: 15.15px !important;\n  color: #1E2939 !important;\n  display: block;\n  margin-bottom: 8px;\n}\n\n.form-control {\n  margin-bottom: 16px !important;\n\n}\n\n.font-montserret-semibold {\n  font-family: var(--font-montserrat-semibold) !important;\n  font-weight: 600 !important;\n}\n\n/* .MuiFormControlLabel-root span {\n  padding: 0px 6px !important;\n} */\n\n.font-roboto-condensed {\n  font-family: var(--font-roboto) !important;\n  font-weight: 400 !important;\n}\n\n.form-control .MuiOutlinedInput-root {\n  border-radius: 10px !important;\n  height: var(--input-height-44) !important;\n}\n\n.form-control .MuiOutlinedInput-root fieldset {\n  border-color: var(--placeholder1) !important;\n}\n\n.form-control .MuiOutlinedInput-root:hover fieldset,\n.form-control .MuiOutlinedInput-root.Mui-focused fieldset {\n  border-color: var(--placeholder1) !important;\n}\n\n.form-control input {\n  padding: 0 19px !important;\n  font-weight: 500 !important;\n  font-size: var(--font-size-small) !important;\n  color: var(--input-color1) !important;\n  font-family: var(--font-montserrat-medium) !important;\n  height: 100% !important;\n  box-sizing: border-box !important;\n}\n\n.form-control.muiBase-control input {\n  padding: 5px 14px 5px 2px !important;\n}\n\n\n.form-control input::placeholder {\n  color: var(--placeholder1) !important;\n  font-weight: 300 !important;\n  font-size: var(--font-size-small) !important;\n  font-family: var(--font-readex-pro-light) !important;\n  opacity: 1 !important;\n}\n\n.login-text {\n  font-weight: 600 !important;\n  font-size: var(--font-size-small) !important;\n  color: var(--input-color1) !important;\n  font-family: var(--font-montserrat-semibold) !important;\n}\n\n@media (max-width: 767px) {\n  .form-label {\n    font-size: 13px !important;\n  }\n}\n\n/* Custom Photo Tabs */\n.photo-tab {\n  width: 49%;\n  padding: 10px 12px;\n  border-radius: 15.1px;\n  font-size: 14.1px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: 1px solid #d1d5db;\n  background-color: #fff;\n  color: #000;\n  font-family: var(--font-montserrat-medium), sans-serif;\n  text-align: center;\n}\n\n.photo-tab.active {\n  background-color: #6318C6;\n  color: #fff;\n  border-color: #6318C6;\n}\n\n.btn-click {\n  background-color: #E8E4F0 !important;\n  color: #651BC6 !important;\n  border-radius: 10.8px !important;\n  padding: 10px 20px !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  border: none !important;\n  cursor: pointer !important;\n  transition: all 0.3s ease !important;\n  font-family: \"Montserrat\", sans-serif !important;\n  text-transform: none !important;\n  box-shadow: none !important;\n}\n\n@media (max-width: 600px) {\n  .btn-click {\n    font-size: 14.03px !important;\n    padding: 12px 23px !important;\n  }\n}\n\n.btn-click:hover {\n  background-color: #dad4e8 !important;\n}\n\n.guideline-link {\n  color: #651BC6 !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  text-decoration: none !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 4px !important;\n  cursor: pointer !important;\n  font-family: \"Montserrat\", sans-serif !important;\n  text-transform: none !important;\n  margin-top: 15px !important;\n}\n\n@media (max-width: 600px) {\n  .guideline-link {\n    font-size: 11.99px !important;\n  }\n}\n\n.guideline-link:hover {\n  text-decoration: none !important;\n  opacity: 0.8;\n}\n\n.up-area {\n  padding: 20px 20px !important;\n}\n\n.border-outln {\n  border: 1px solid #651BC6 !important;\n}\n\n.ai-attributes-title {\n  font-size: 17.31px;\n  font-family: var(--font-montserrat-semibold) !important;\n  color: #1E2939;\n}\n\n/* Jewellery Type Grid */\n.select-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n  margin-top: 15px;\n  margin-bottom: 5px;\n}\n\n@media (min-width: 1024px) {\n  .select-grid {\n    grid-template-columns: repeat(5, 1fr);\n  }\n}\n\n.select-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 5px;\n  cursor: pointer;\n  width: 100%;\n}\n\n.select-box {\n  width: 100px;\n  aspect-ratio: 1 / 1;\n  background-color: #fff;\n  border: 2px solid #D1D1D1;\n  border-radius: 11.69px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  transition: all 0.3s ease;\n  padding: 12px;\n  box-sizing: border-box;\n  overflow: hidden;\n  height: 100px;\n}\n\n.model-face-select-box {\n  height: 160px !important;\n}\n\n.model-face-select-box img {\n  object-fit: cover !important;\n}\n\n.select-box.selected {\n  border: 2px solid #651BC6;\n}\n\n.select-image {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n.select-checkbox {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 18px;\n  height: 18px;\n  border: 2px solid #651BC6;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #fff;\n  z-index: 2;\n}\n\n.select-label {\n  font-family: var(--font-montserrat-medium) !important;\n  font-size: 14.17px !important;\n  color: #000;\n  text-align: center;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  line-height: 1.2;\n  width: 100%;\n  padding: 0 4px;\n  box-sizing: border-box;\n  white-space: normal !important;\n  overflow-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n.select-item.selected .select-label {\n  color: #651BC6 !important;\n}\n\n/* Specific styling for AI Attributes (Ethnicity, Clothing Type, Bust Finish) to fill card completely */\n.attribute-select-box {\n  padding: 0 !important;\n  background-color: #CFC2AC !important;\n}\n\n.attribute-select-image {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: cover !important;\n}\n\n.model-face-select-image {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: contain !important;\n}\n\n.model-face-select-box {\n  background-color: #fff !important;\n}\n\n@media (max-width: 767px) {\n  .jewellery-grid {\n    gap: 10px;\n  }\n\n  .jewellery-label {\n    font-size: 13.5px;\n  }\n}\n\n@media (min-width: 768px) {\n  .photo-tab {\n    padding: 10px 12px;\n  }\n}\n\n/* Radio Button Select Cards */\n.select-radio {\n  margin: 0 !important;\n  border: 2px solid #D1D1D1 !important;\n  border-radius: 15.15px !important;\n  padding: 12px 16px !important;\n  transition: all 0.3s ease !important;\n  background-color: white !important;\n  flex: 1 !important;\n  height: 53px !important;\n  min-height: 53px !important;\n  display: flex !important;\n  align-items: center !important;\n  box-sizing: border-box !important;\n  min-width: 0 !important;\n}\n\n.select-radio:hover {\n  border-color: #651BC6 !important;\n  background-color: #F9F6FE !important;\n}\n\n.select-radio.selected {\n  border-color: #651BC6 !important;\n  border-width: 2px !important;\n  background-color: #F9F6FE !important;\n}\n\n.select-radio .MuiRadio-root {\n  padding: 8px !important;\n  margin-right: 2px !important;\n  color: #D1D1D1 !important;\n}\n\n.select-radio .MuiRadio-root:hover {\n  background-color: rgba(101, 27, 198, 0.04) !important;\n}\n\n.select-radio .MuiRadio-root.Mui-checked {\n  color: #651BC6 !important;\n}\n\n.select-radio .MuiRadio-root.Mui-checked svg:nth-of-type(2),\n.select-radio .MuiRadio-root.Mui-checked svg[data-testid=\"RadioButtonCheckedIcon\"] {\n  transform: scale(0.8) !important;\n  transform-origin: center !important;\n}\n\n.select-radio .MuiSvgIcon-root {\n  font-size: 22px !important;\n  margin-right: 2px !important;\n}\n\n.select-radio .MuiFormControlLabel-label {\n  color: #1F2937 !important;\n  flex: 1 !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  font-family: var(--font-montserrat-medium) !important;\n  font-weight: 500 !important;\n  font-size: 15.15px !important;\n}\n\n.select-radio .MuiFormControlLabel-label span {\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  min-width: 0 !important;\n}\n\n.select-radio.selected .MuiFormControlLabel-label span {\n  color: #651BC6 !important;\n}\n\n@media (max-width: 380px) {\n  .select-radio {\n    padding: 8px 10px !important;\n  }\n\n  .select-radio .MuiFormControlLabel-label {\n    font-size: 14.17px !important;\n    gap: 2px !important;\n  }\n}\n\n/* Media Quality Popup Styles */\n.media-title {\n  color: #1E2939 !important;\n  font-weight: 600 !important;\n  margin-bottom: 24px !important;\n  font-family: var(--font-montserrat-semibold) !important;\n  font-size: 15.15px !important;\n}\n\n.media-label {\n  font-weight: 700 !important;\n  color: #1E2939 !important;\n  font-size: 11.07px !important;\n  margin-bottom: 1.6px !important;\n  font-family: var(--font-montserrat-bold) !important;\n  text-align: center;\n}\n\n.media-res {\n  color: #1E2939 !important;\n  font-size: 11.07px !important;\n  font-weight: 500 !important;\n  font-family: var(--font-montserrat-medium) !important;\n  text-align: center;\n}\n\n.item-label {\n  font-size: 14.5px !important;\n  color: #9B9B9B !important;\n  font-family: var(--font-montserrat-medium) !important;\n  font-weight: 500 !important;\n  margin-bottom: 3px !important;\n  line-height: 1.3 !important;\n}\n\n.item-value {\n  font-size: 14.5px !important;\n  color: #111827 !important;\n  font-family: var(--font-montserrat-semibold) !important;\n  font-weight: 700 !important;\n  line-height: 1.3 !important;\n}\n\n.generation-details {\n  border-radius: 10.29px;\n  border: 1px solid #E5E7EB;\n  padding: 16px 20px;\n  margin-bottom: 5px;\n}\n\n.dialog-actions-custom {\n  padding: 15px 17px 15px 17px !important;\n  /* pt:0.5, px:2.5, pb:2.5 */\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  /* 1.5 * 8 = 12px */\n  justify-content: stretch;\n  border-top: 1px solid #E5E7EB;\n\n  /* box shadow */\n  box-shadow: 0px -3.48px 10.43px 0px rgba(0, 0, 0, 0.05);\n}\n\n.font-14 {\n  font-size: 14px !important;\n}\n\n.p-12-0 {\n  padding: 12px 0px !important;\n}\n\n.preview-content {\n  padding: 12px 14px 7px 14px !important;\n}\n\n.loader-card {\n  padding: 50px 20px 10px 20px;\n}\n\n.loader-card-progress {\n  padding: 10px 30px;\n}\n\n/* Profile Form Styles */\n.profile-input-label {\n  font-family: 'Montserrat', sans-serif !important;\n  font-size: 14px !important;\n  color: #000000 !important;\n  font-weight: 500 !important;\n  margin-bottom: 8px !important;\n}\n\n.profile-form-control .MuiOutlinedInput-root {\n  border-radius: 13.47px !important;\n  height: 48px !important;\n  background-color: #ffffff;\n}\n\n.profile-form-control .MuiOutlinedInput-notchedOutline {\n  border-color: #C1C1C1 !important;\n}\n\n.profile-form-control .MuiInputBase-input {\n  font-family: 'Montserrat', sans-serif !important;\n  font-size: 14px !important;\n  color: #000 !important;\n  font-weight: 400 !important;\n}\n\n.profile-form-control .MuiInputBase-input::placeholder {\n  font-family: 'Montserrat', sans-serif !important;\n  font-size: 14px !important;\n  color: #919191 !important;\n  font-weight: 400 !important;\n  opacity: 1 !important;\n}\n\n/* Generation History Action Buttons */\n.action-button-grid {\n  display: grid !important;\n  grid-template-columns: 1fr 1fr !important;\n  gap: 12px !important;\n}\n\n.action-btn {\n  height: 40px !important;\n  border-radius: 10.96px !important;\n  border: 1px solid #E5E7EB !important;\n  background-color: #F3F4F6 !important;\n  color: #6B7280 !important;\n  font-weight: 500 !important;\n  text-transform: none !important;\n  font-size: 14px !important;\n  font-family: var(--font-montserrat-medium, Montserrat, sans-serif) !important;\n}\n\n.action-btn:hover:not(:disabled):not(.Mui-disabled) {\n  background-color: #6318C6 !important;\n  border-color: #6318C6 !important;\n  color: #fff !important;\n}\n\n.action-btn:disabled,\n.action-btn.Mui-disabled {\n  background-color: #F3F4F6 !important;\n  border-color: #E5E7EB !important;\n  color: #6B7280 !important;\n}\n\n/* Generation History Card Typography and Layout classes */\n.gen-thumbnail {\n  width: 90px;\n  height: 150px;\n  border-radius: 12px;\n  flex-shrink: 0;\n  overflow: hidden;\n  background-color: #f5f5f5;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.gen-video-preview {\n  width: 90px;\n  height: 150px;\n  position: relative;\n  cursor: pointer;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.gen-video-preview:hover {\n  transform: scale(1.03);\n}\n\n.gen-play-btn {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: rgba(0, 0, 0, 0.55);\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.gen-video-placeholder {\n  width: 90px;\n  height: 90px;\n  background-color: #1e293b;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  position: relative;\n  cursor: pointer;\n}\n\n/* Category Title */\n.gen-category-title {\n  font-size: 17.53px !important;\n  font-weight: 600 !important;\n  color: #1E2939 !important;\n  font-family: var(--font-montserrat-semibold, Montserrat, sans-serif) !important;\n  margin-bottom: 6px !important;\n  line-height: 1.3 !important;\n}\n\n/* Status Badges */\n.gen-badge-processing {\n  height: 30px;\n  display: inline-flex !important;\n  align-items: center !important;\n  padding: 0 12px !important;\n  border-radius: 100px !important;\n  background-color: #DBEAFE !important;\n  color: #1D4ED8 !important;\n  font-family: var(--font-montserrat-semibold, Montserrat, sans-serif) !important;\n  font-weight: 600 !important;\n  font-size: 13px !important;\n  white-space: nowrap !important;\n}\n\n.gen-badge-completed {\n  height: 30px;\n  display: inline-flex !important;\n  align-items: center !important;\n  padding: 0 12px !important;\n  border-radius: 100px !important;\n  background-color: #D1FAE5 !important;\n  color: #065F46 !important;\n  font-family: var(--font-montserrat-semibold, Montserrat, sans-serif) !important;\n  font-weight: 600 !important;\n  font-size: 13px !important;\n  white-space: nowrap !important;\n}\n\n.gen-badge-failed {\n  height: 30px;\n  display: inline-flex !important;\n  align-items: center !important;\n  padding: 0 12px !important;\n  border-radius: 100px !important;\n  background-color: #FEE2E2 !important;\n  color: #B91C1C !important;\n  font-family: var(--font-montserrat-semibold, Montserrat, sans-serif) !important;\n  font-weight: 600 !important;\n  font-size: 13px !important;\n  white-space: nowrap !important;\n}\n\n.gen-badge-cancelled {\n  height: 30px;\n  display: inline-flex !important;\n  align-items: center !important;\n  padding: 0 12px !important;\n  border-radius: 100px !important;\n  background-color: #FED7AA !important;\n  color: #EA580C !important;\n  font-family: var(--font-montserrat-semibold, Montserrat, sans-serif) !important;\n  font-weight: 600 !important;\n  font-size: 13px !important;\n  white-space: nowrap !important;\n}\n\n/* Points Badge */\n.gen-badge-tokens {\n  height: 30px;\n  display: inline-flex !important;\n  align-items: center !important;\n  padding: 0 12px !important;\n  border-radius: 100px !important;\n  background-color: #EDE9FE !important;\n  color: #7C3AED !important;\n  font-family: var(--font-montserrat-semibold, Montserrat, sans-serif) !important;\n  font-weight: 600 !important;\n  font-size: 13px !important;\n  white-space: nowrap !important;\n}\n\n/* Date Time Text */\n.gen-datetime {\n  font-size: 13.45px !important;\n  color: #515151 !important;\n  font-family: var(--font-montserrat-regular, Montserrat, sans-serif) !important;\n  font-weight: 400 !important;\n}\n\n/* Custom Tags Wrapper */\n.gen-tags-title {\n  font-size: 15px !important;\n  color: #000000 !important;\n  font-family: var(--font-montserrat-medium, Montserrat, sans-serif) !important;\n  font-weight: 500 !important;\n  margin-bottom: 8px !important;\n}\n\n/* Custom Tag Item */\n.gen-tag-item {\n  height: 30px;\n  display: inline-flex !important;\n  align-items: center !important;\n  padding: 0 12px !important;\n  border-radius: 100px !important;\n  background-color: #651BC6 !important;\n  color: #fff !important;\n  font-family: var(--font-montserrat-medium, Montserrat, sans-serif) !important;\n  font-weight: 500 !important;\n  font-size: 13px !important;\n  white-space: nowrap !important;\n}\n\n/* Custom Tag Extra (+N) */\n.gen-tag-extra {\n  width: 30px;\n  height: 30px;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  border-radius: 100px !important;\n  background-color: #EDE9FE !important;\n  color: #7C3AED !important;\n  font-family: var(--font-montserrat-medium, Montserrat, sans-serif) !important;\n  font-weight: 600 !important;\n  font-size: 12px !important;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n/* Custom Tag Show Less */\n.gen-tag-less {\n  height: 30px;\n  display: inline-flex !important;\n  align-items: center !important;\n  padding: 0 12px !important;\n  border-radius: 100px !important;\n  background-color: #F3F4F6 !important;\n  color: #6B7280 !important;\n  font-family: var(--font-montserrat-medium, Montserrat, sans-serif) !important;\n  font-weight: 500 !important;\n  font-size: 12px !important;\n  cursor: pointer;\n}\n\n\n@media (max-width: 375px) {\n  .gen-thumbnail {\n    width: 87px !important;\n    height: 140px !important;\n  }\n\n  .gen-category-title {\n    font-size: 15.53px !important;\n    margin-bottom: 7px !important;\n  }\n\n  .gen-badge-failed,\n  .gen-badge-completed,\n  .gen-badge-processing,\n  .gen-badge-cancelled,\n  .gen-badge-tokens {\n    height: 25px !important;\n    font-size: 12px !important;\n  }\n\n  .gen-datetime {\n    font-size: 11.45px !important;\n  }\n\n  .gen-tags-title {\n    font-size: 13px !important;\n  }\n\n  .gen-tag-item {\n    height: 28px !important;\n    padding: 2px 14px !important;\n    font-size: 11px !important;\n  }\n\n  .gen-tag-extra {\n    width: 28px !important;\n    height: 28px !important;\n    font-size: 12.45px !important;\n  }\n\n  .action-btn {\n    height: 38px !important;\n    font-size: 13px !important;\n  }\n\n  .gen-tag-less {\n    height: 28px !important;\n    padding: 2px 14px !important;\n    font-size: 12px !important;\n  }\n\n  /* Custom date picker styling to allow native calendar overlay on the full input */\n  .custom-date-picker::-webkit-calendar-picker-indicator {\n    background: transparent;\n    bottom: 0;\n    color: transparent;\n    cursor: pointer;\n    height: auto;\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: auto;\n  }\n}\n\n.btn-primary-app {\n  background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%) !important;\n  color: var(--text-white);\n  border-radius: 40px;\n  padding: 10px 28px;\n  font-size: var(--font-size-regular);\n  font-weight: var(--font-medium);\n  border: none;\n  transition: background 0.5s ease;\n  display: inline-block;\n  width: fit-content;\n}\n\n.btn-primary-web {\n  background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%) !important;\n  color: var(--text-white);\n  border-radius: 40px;\n  padding: 10px 28px;\n  font-size: var(--font-size-small);\n  font-weight: var(--font-medium);\n  border: none;\n  transition: background 0.5s ease;\n  display: inline-block;\n  width: fit-content;\n}\n\n.btn-primary-web:hover {\n  background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%) !important;\n  transition: background 0.5s ease;\n  color: var(--text-white);\n\n}\n\n@media (max-width: 767px) {\n  .text-span {\n    font-size: 9px !important;\n  }\n}\n\n.text-span {\n  font-size: 10px;\n  letter-spacing: 0.5px;\n  color: #000000;\n  font-family: var(--font-montserrat-medium)\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
